import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { unReadNotice } from "api/notice";
import { Badge } from "react-vant";
import styles from "./widget.module.less";
import DSBridge from "dsbridge";

function NoticeWidget() {
  const navigator = useNavigate();
  const [notice, setNotice] = useState({});
  const [count, setCount] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      await unReadNotice().then((res) => {
        if (res.code === 200) {
          setNotice(res.data.data);
          setCount(res.data.total_count);
          if (
            DSBridge.hasNativeMethod("push.setBadge") &&
            typeof res.data?.total_count === "number"
          ) {
            DSBridge.call("push.setBadge", { count: res.data?.total_count });
          }
        }
      });
    };
    fetchData();
  }, []);

  return (
    <div className={styles["main-container"]}>
      <div className={styles["left"]}>
        {count > 0 ? (
          <Badge
            className={styles["badge"]}
            content={count}
            max="99"
            offset={["50%", 3]}
          >
            <img
              src={require(`@/images/notice/m_icon.png`)}
              className={styles["badge-container"]}
              alt=""
            />
          </Badge>
        ) : (
          <img
            src={require(`@/images/notice/m_icon.png`)}
            className={styles["badge-container"]}
            alt=""
          />
        )}
        <div className={styles["title"]}>{notice.message_title}</div>
      </div>
      <div
        className={styles["right"]}
        onClick={() => {
          if (localStorage.getItem("access_token")) {
            navigator("/main/notice");
          } else {
            navigator("/login/logon");
          }
        }}
      >
        立即查看 <img src={require(`@/images/notice/m_arrow.png`)} alt="" />
      </div>
    </div>
  );
}

export default NoticeWidget;
